import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { DailySettlementWrapper } from "../../components";

export default function DailySettlementPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <DailySettlementWrapper organization={organization} />
    </ModalProvider>
  );
}
